import React from 'react';
import { useTranslation } from 'react-i18next';
import './TermsOfService.css';
import Footer2 from '../footer';

const TermsOfService = () => {
  const { t } = useTranslation();
  
  return (
    <div className="terms-of-service">
      <div className="terms-header">
        <div className="header-decoration">
          <div className="decoration-circle circle-1"></div>
          <div className="decoration-circle circle-2"></div>
          <div className="decoration-circle circle-3"></div>
        </div>
        <h1 className="terms-title">{t('terms.title')}</h1>
        <p className="last-updated">{t('terms.lastUpdated')}</p>
        <div className="header-line"></div>
      </div>

      <div className="terms-content  mb-3">
        {/* Existing sections 1-11 */}
        <section className="terms-section">
          <div className="section-header">
            <span className="section-number">01</span>
            <h2>{t('terms.section1.title')}</h2>
          </div>
          <p>{t('terms.section1.content')}</p>
        </section>

        <section className="terms-section">
          <div className="section-header">
            <span className="section-number">02</span>
            <h2>{t('terms.section2.title')}</h2>
          </div>
          <p>{t('terms.section2.content')}</p>
        </section>

        <section className="terms-section">
          <div className="section-header">
            <span className="section-number">03</span>
            <h2>{t('terms.section3.title')}</h2>
          </div>
          <p>{t('terms.section3.content')}</p>
        </section>

        <section className="terms-section">
          <div className="section-header">
            <span className="section-number">04</span>
            <h2>{t('terms.section4.title')}</h2>
          </div>
          <p>{t('terms.section4.content')}</p>
        </section>

        <section className="terms-section">
          <div className="section-header">
            <span className="section-number">05</span>
            <h2>{t('terms.section5.title')}</h2>
          </div>
          <p>{t('terms.section5.content')}</p>
        </section>

        <section className="terms-section">
          <div className="section-header">
            <span className="section-number">06</span>
            <h2>{t('terms.section6.title')}</h2>
          </div>
          <p>{t('terms.section6.content')}</p>
        </section>

        <section className="terms-section">
          <div className="section-header">
            <span className="section-number">07</span>
            <h2>{t('terms.section7.title')}</h2>
          </div>
          <p>{t('terms.section7.content')}</p>
        </section>

        <section className="terms-section">
          <div className="section-header">
            <span className="section-number">08</span>
            <h2>{t('terms.section8.title')}</h2>
          </div>
          <p>{t('terms.section8.content')}</p>
        </section>

        <section className="terms-section">
          <div className="section-header">
            <span className="section-number">09</span>
            <h2>{t('terms.section9.title')}</h2>
          </div>
          <p>{t('terms.section9.content')}</p>
        </section>

        <section className="terms-section">
          <div className="section-header">
            <span className="section-number">10</span>
            <h2>{t('terms.section10.title')}</h2>
          </div>
          <p>{t('terms.section10.content')}</p>
        </section>

        <section className="terms-section">
          <div className="section-header">
            <span className="section-number">11</span>
            <h2>{t('terms.section11.title')}</h2>
          </div>
          <p>{t('terms.section11.content')}</p>
        </section>

        {/* New sections 12-20 */}
        <section className="terms-section">
          <div className="section-header">
            <span className="section-number">12</span>
            <h2>{t('terms.section12.title')}</h2>
          </div>
          <p>{t('terms.section12.content')}</p>
        </section>

        <section className="terms-section">
          <div className="section-header">
            <span className="section-number">13</span>
            <h2>{t('terms.section13.title')}</h2>
          </div>
          <p>{t('terms.section13.content')}</p>
        </section>

        <section className="terms-section">
          <div className="section-header">
            <span className="section-number">14</span>
            <h2>{t('terms.section14.title')}</h2>
          </div>
          <p>{t('terms.section14.content')}</p>
        </section>

        <section className="terms-section">
          <div className="section-header">
            <span className="section-number">15</span>
            <h2>{t('terms.section15.title')}</h2>
          </div>
          <p>{t('terms.section15.content')}</p>
        </section>

        <section className="terms-section">
          <div className="section-header">
            <span className="section-number">16</span>
            <h2>{t('terms.section16.title')}</h2>
          </div>
          <p>{t('terms.section16.content')}</p>
        </section>

        <section className="terms-section">
          <div className="section-header">
            <span className="section-number">17</span>
            <h2>{t('terms.section17.title')}</h2>
          </div>
          <p>{t('terms.section17.content')}</p>
        </section>

        <section className="terms-section">
          <div className="section-header">
            <span className="section-number">18</span>
            <h2>{t('terms.section18.title')}</h2>
          </div>
          <p>{t('terms.section18.content')}</p>
        </section>

        <section className="terms-section">
          <div className="section-header">
            <span className="section-number">19</span>
            <h2>{t('terms.section19.title')}</h2>
          </div>
          <p>{t('terms.section19.content')}</p>
        </section>

        <section className="terms-section mb-5">
          <div className="section-header">
            <span className="section-number">20</span>
            <h2>{t('terms.section20.title')}</h2>
          </div>
          <p>{t('terms.section20.content')}</p>
        </section>
      </div>

      {/* <div className="terms-footer">
        <div className="footer-line"></div>
        <p className="footer-text">{t('terms.footer')}</p>
      </div> */}


      <Footer2 style={{ textAlign: 'center' }}>
        </Footer2>
    </div>
  );
};

export default TermsOfService;